export type ApiErrorCode =
  | 'network'
  | 'authentication_required'
  | 'auth_verifier_unavailable'
  | 'legal_acceptance_required'
  | 'stale_legal_version'
  | 'forbidden'
  | 'not_found'
  | 'server'
  | 'unknown';

export class ApiError extends Error {
  readonly code: ApiErrorCode;
  readonly status?: number;

  constructor(message: string, code: ApiErrorCode, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}

export function apiErrorFromStatus(status: number, message?: string, backendCode?: string): ApiError {
  if (backendCode === 'authentication_required' || backendCode === 'invalid_auth_token') {
    return new ApiError(message || 'Authentication required', 'authentication_required', status);
  }
  if (backendCode === 'auth_verifier_unavailable') {
    return new ApiError(message || 'Configured auth verifier is not available', 'auth_verifier_unavailable', status);
  }
  if (backendCode === 'legal_acceptance_required') {
    return new ApiError(message || 'Legal acceptance required', 'legal_acceptance_required', status);
  }
  if (backendCode === 'stale_legal_version') {
    return new ApiError(message || 'Submitted legal version is stale', 'stale_legal_version', status);
  }
  if (status === 401) return new ApiError(message || 'Authentication required', 'authentication_required', status);
  if (status === 403) {
    const legalAcceptanceSignal = message?.toLowerCase().match(/\b(legal|terms|acceptance)\b/);
    if (legalAcceptanceSignal) return new ApiError(message || 'Legal acceptance required', 'legal_acceptance_required', status);
    return new ApiError(message || 'Forbidden', 'forbidden', status);
  }
  if (status === 503 && message?.toLowerCase().includes('auth verifier')) {
    return new ApiError(message, 'auth_verifier_unavailable', status);
  }
  if (status === 404) return new ApiError(message || 'Not found', 'not_found', status);
  if (status >= 500) return new ApiError(message || 'Server error', 'server', status);
  return new ApiError(message || 'Request failed', 'unknown', status);
}
